import { buildDownloadData } from '@/pages/intelligence/utils/commonUtils';

export function getPCConsoleAmpereOverlapConfig(list: any, params: any, allParams: any) {
  const items = (list?.rank_list || []).flatMap((item: any) => {
    const metricList = Array.isArray(item?.metric_list) ? item.metric_list : [];
    if (!metricList.length) {
      return [{
        ...item,
        active_users: '',
        download_region: '',
      }];
    }
    return metricList.map((metric: any) => ({
      ...item,
      active_users: metric?.active_users,
      download_region: metric?.region,
    }));
  });
  const statConfig = [
    { title: 'Game Name', key: (item: any) => item?.name || '' },
    {
      title: 'Publisher Company Name',
      key: (item: any) => item?.publisher || '',
      when: () => allParams?.company_show === 1,
    },
    {
      title: 'IEGG Main Genre',
      key: (item: any) => item?.iegg_genre || '',
      when: () => allParams?.genre_show === 1,
    },
    {
      title: 'IEGG Sub Genre',
      key: (item: any) => item?.iegg_sub_genre || '',
      when: () => allParams?.genre_show === 1,
    },
    {
      title: 'Steam Tag',
      key: (item: any) => item?.steam_tag || '',
      when: () => allParams?.steam_tag_show === 1,
    },
    {
      title: 'Release Date',
      key: (item: any) => item?.release_time || '',
      when: () => allParams?.release_date_show === 1,
    },
    { title: 'Active Users', key: (item: any) => item?.active_users ?? '' },
    {
      title: 'Region/Country',
      key: (item: any) => item?.download_region || '',
    },
  ];

  return {
    stat: {
      sheetName: params?.download_region_type === 'market' ? 'By Country' : 'By Region',
      style: 'normal',
      data: buildDownloadData(statConfig, items),
    },
    summary: {
      sheetName: 'Filter information',
      style: 'first col bold',
      data: [
        ['Date Range', `${allParams?.start_date || ''} ~ ${allParams?.end_date || ''}`],
        ['Platform', (allParams?.platforms || []).join(', ') || 'All'],
        ['Region/Countries', (allParams?.download_regions || []).join(', ')],
        ['Steam Tags', (allParams?.steam_tag || []).join(', ') || 'All'],
        ['IEGG Genre', (allParams?.iegg_genre_req || []).join(', ') || 'All'],
      ],
    },
  };
}
